<template>
  <button
    :type="type"
    class="btn"
    :class="classes"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
      validator: function (value) {
        return ['button', 'submit'].indexOf(value) !== -1
      }
    },
    buttonStyle: {
      type: String,
      default: 'primary',
      validator: function (value) {
        return ['primary', 'danger', 'secondary'].indexOf(value) !== -1
      }
    },
    isOutline: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      let styleClass = `btn-${this.buttonStyle}`
      styleClass += this.isOutline ? '-outline' : ''

      return [styleClass]
    }
  }
}
</script>
